import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_SHARE_FOR_STARTERS_MIGRATION = defineFcm('growth_share_for_starters_migration')
	.asBoolean()
	.withDefault(false)
	.toConfig();
